export enum Flow {
  INIT = 'INIT',

  // ==============================================
  // Login
  // ==============================================
  LOGIN_SOCIAL_LOGIN_MORE = 'LOGIN_SOCIAL_LOGIN_MORE',
  LOGIN_STEP_ALL_DONE = 'LOGIN_STEP_ALL_DONE',

  LOGIN_STEP_CHOOSE_ACCOUNT = 'SSO_CHOOSE_ACCOUNT',
  LOGIN_STEP_DISABLE = 'LOGIN_STEP_DISABLE',
  LOGIN_STEP_DISABLE_RECOVERY = 'LOGIN_STEP_DISABLE_RECOVERY',
  LOGIN_STEP_ENABLE_PASSKEY = 'LOGIN_STEP_ENABLE_PASSKEY',
  LOGIN_STEP_INPUT_PASSWORD = 'LOGIN_STEP_INPUT_PASSWORD',
  LOGIN_STEP_INPUT_USERNAME = 'LOGIN_STEP_INPUT_USERNAME',
  LOGIN_STEP_MFA = 'MFA_STEP_INPUT_CODE',
  LOGIN_STEP_ENFORCED_MFA = 'ENFORCE_MFA_STEP_INPUT_CODE',

  LOGIN_STEP_ROAM_GRANT = 'LOGIN_STEP_ROAM_GRANT',
  LOGIN_STEP_SUCCESS_CALLBACK = 'LOGIN_STEP_SUCCESS_CALLBACK',
  LOGIN_STEP_SOCIAL_UNAUTHORIZED = 'LOGIN_STEP_SOCIAL_UNAUTHORIZED',
  LOGIN_STEP_SOCIAL_ERROR = 'LOGIN_STEP_SOCIAL_ERROR',
  // ==============================================
  // Register
  // ==============================================
  REGISTER_STEP_ENABLE_PASSKEY = 'REGISTER_STEP_ENABLE_PASSKEY',
  REGISTER_STEP_INPUT_CODE = 'REGISTER_STEP_INPUT_CODE',
  REGISTER_STEP_INPUT_PASSWORD = 'REGISTER_STEP_INPUT_PASSWORD',
  REGISTER_STEP_INPUT_USERINFO = 'REGISTER_STEP_INPUT_USERINFO',
  REGISTER_STEP_ALL_DONE = 'REGISTER_STEP_ALL_DONE',
  REGISTER_STEP_OPEN_APP = 'REGISTER_STEP_OPEN_APP',
  REGISTER_STEP_SUCCESS_CALLBACK = 'REGISTER_STEP_SUCCESS_CALLBACK',

  // REGISTER_EXCEPTION_REQUEST_BLOCKED = 'REGISTER_EXCEPTION_REQUEST_BLOCKED',

  // ==============================================
  // Reset
  // ==============================================
  RESET_PASSWORD_STEP_INPUT_CODE = 'RESET_PASSWORD_STEP_INPUT_CODE',
  RESET_PASSWORD_STEP_INPUT_USERNAME = 'RESET_PASSWORD_STEP_INPUT_USERNAME',
  RESET_PASSWORD_STEP_INPUT_PASSWORD = 'RESET_PASSWORD_STEP_INPUT_PASSWORD',
  RESET_PASSWORD_STEP_COMPLETE = 'RESET_PASSWORD_STEP_COMPLETE',

  // ==============================================
  // RECOVERY
  // ==============================================
  RECOVERY_STEP_INPUT_CODE = 'RECOVERY_STEP_INPUT_CODE',
  RECOVERY_STEP_INPUT_USERNAME = 'RECOVERY_STEP_INPUT_USERNAME',
  RECOVERY_STEP_INPUT_PASSWORD = 'RECOVERY_STEP_INPUT_PASSWORD',
  RECOVERY_STEP_COMPLETE = 'RECOVERY_STEP_COMPLETE',

  // ==============================================
  // Third
  // ==============================================

  THIRD_STEP_SOCIAL_LOGIN = 'THIRD_STEP_SOCIAL_LOGIN',

  // ==============================================
  // AUTHORIZATION
  // ==============================================
  LOGIN_STEP_AUTHORIZATION = 'LOGIN_STEP_AUTHORIZATION',

  // ==============================================
  // OPENAPP
  // ==============================================
  LOGIN_STEP_OPEN_APP = 'LOGIN_STEP_OPEN_APP',

  LOGOUT_STEP_SUCCESS_CALLBACK = 'LOGOUT_STEP_SUCCESS_CALLBACK',

  // ==============================================
  // Exception
  // ==============================================
  EXCEPTION_COOKIE_BLOCKED = 'EXCEPTION_COOKIE_BLOCKED',
  EXCEPTION_REQUEST_BLOCKED = 'EXCEPTION_REQUEST_BLOCKED',
  EXCEPTION_SOMETHING_WENT_WRONG = 'EXCEPTION_SOMETHING_WENT_WRONG',
  EXCEPTION_SAFETY_TIPS = 'EXCEPTION_SAFETY_TIPS',
  EXCEPTION_EXPIRED_CODE = 'EXCEPTION_EXPIRED_CODE',
  EXCEPTION_TROUBLESHOOTING = 'EXCEPTION_TROUBLESHOOTING',
  EXCEPTION_REQUEST_TIMEOUT = 'EXCEPTION_REQUEST_TIMEOUT',
  EXCEPTION_NETWORK_ERROR = 'EXCEPTION_NETWORK_ERROR',
}

export const LOGIN_FLOW = [
  Flow.LOGIN_STEP_INPUT_USERNAME,
  Flow.LOGIN_STEP_INPUT_PASSWORD,
  Flow.LOGIN_STEP_MFA,
  Flow.LOGIN_SOCIAL_LOGIN_MORE,
  Flow.LOGIN_STEP_ENABLE_PASSKEY,
  Flow.LOGIN_STEP_CHOOSE_ACCOUNT,
  Flow.LOGIN_STEP_ROAM_GRANT,
  Flow.LOGIN_STEP_DISABLE_RECOVERY,
  Flow.LOGIN_STEP_DISABLE,
  Flow.LOGIN_STEP_ALL_DONE,
  Flow.LOGIN_STEP_SUCCESS_CALLBACK,
  Flow.LOGIN_STEP_SOCIAL_UNAUTHORIZED,
  Flow.LOGIN_STEP_SOCIAL_ERROR,
];

export const THIRD_FLOW = [Flow.THIRD_STEP_SOCIAL_LOGIN];

export const OPENAPP_FLOW = [Flow.LOGIN_STEP_OPEN_APP];

export const AUTHORIZATION_FLOW = [Flow.LOGIN_STEP_AUTHORIZATION];

export const REGISTER_FLOW = [
  Flow.REGISTER_STEP_INPUT_USERINFO,
  Flow.REGISTER_STEP_INPUT_CODE,
  Flow.REGISTER_STEP_INPUT_PASSWORD,
  Flow.REGISTER_STEP_ENABLE_PASSKEY,
  Flow.REGISTER_STEP_ALL_DONE,
];

export const RESET_FLOW = [
  Flow.RESET_PASSWORD_STEP_INPUT_USERNAME,
  Flow.RESET_PASSWORD_STEP_INPUT_CODE,
  Flow.RESET_PASSWORD_STEP_INPUT_PASSWORD,
  Flow.RESET_PASSWORD_STEP_COMPLETE,
];

export const RECOVERY_FLOW = [
  Flow.RECOVERY_STEP_INPUT_USERNAME,
  Flow.RECOVERY_STEP_INPUT_CODE,
  Flow.RECOVERY_STEP_INPUT_PASSWORD,
  Flow.RECOVERY_STEP_COMPLETE,
];
